<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    :title="`批量${scenetypeDesc}`"
    :visible.sync="visible"
    width="512px"
    :destroy-on-close="true"
    @open="handleOpen"
    :show-close="true"
    :before-close="handleCancel"
  >
    <Success
      v-if="status"
      v-bind="$attrs"
      v-on="$listeners"
      :dingTalkShow="dingTalkShow"
    />
    <SubmitForm
      v-if="!status"
      v-bind="$attrs"
      v-on="$listeners"
      @handleSuccess="handleSuccess"
    />
  </el-dialog>
</template>

<script>
import Success from './Success/index.vue'
import SubmitForm from './SubmitForm.vue'

export default {
  name: 'RejectResouceComponent',
  components: {
    Success,
    SubmitForm,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dingTalkShow: false, // 是否开启审批
      status: false,
    }
  },
  computed: {
    scenetypeDesc() {
      const _map = new Map([['receivable', '收款'], ['payment', '付款']])
      return _map.get(this.$attrs.scenetype) || '--'
    },
  },
  methods: {
    handleOpen() {
      this.status = false
    },
    handleSuccess(dingTalkShow) {
      this.$emit('refresh')
      this.dingTalkShow = dingTalkShow
      this.status = true
    },
    handleCancel() {
      this.status = false
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.dialogWrap-box {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
.import-policy-info-form {
  padding-top: 12px;
  .form-item-wrapper {
  }
}
.form-row {
  margin-bottom: 12px;
}
.info-slot {
  position: relative;
  top: -12px;
  margin-left: 100px;
}
::v-deep .el-form-item.is-error + .info-slot {
  top: -4px;
}
.file-row {
  display: flex;
  justify-content: flex-start;
  .file-name-wrapper {
    // flex: 1;
    display: flex;
    align-items: center;
    .file-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    ::v-deep .el-icon-document {
      flex: none;
      margin-right: 2px;
    }
    ::v-deep .el-icon-circle-check {
      flex: none;
      margin-left: 6px;
      color: #67c23a;
    }
  }
  .file-btns {
    flex: 1;
    display: flex;
    align-items: center;
    margin-left: 24px;
    ::v-deep .el-icon-download:hover {
      color: #409eff;
      cursor: pointer;
    }
    ::v-deep .el-icon-delete {
      margin-left: 8px;
      &:hover {
        color: #409eff;
        cursor: pointer;
      }
    }
  }
}
</style>
